import '../App.css';
import { useLocation } from "react-router-dom";

export default function MissingPage() {

  const location = useLocation().pathname
  console.log(location, "test")

  return (
    <div>
      <div className="centerText">
        Page not found. If you got here through a valid link, please reselect the page you were attempting to reach from the navigation menu on the left.
      </div>
    </div>
  );
}